// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules

// App
import { apiEndpoints } from "../../config";

import { FormControlLabel, Checkbox, Typography } from "@mui/material";
import PostEdit from "../../partials/posts/postEdit";

export default function QuizEdit() {
  const [editorContent, setEditorContent] = useState("");
  const [questions, setQuestions] = useState([]);
  const [post, setPost] = useState({});
  const [allowSubmission, setAllowSubmission] = useState(false);

  useEffect(() => {
    if (editorContent && editorContent.blocks) {
      const questions = editorContent.blocks
        .filter((block) => block.type === "question")
        .map((questionBlock) => {
          return { ...questionBlock.data };
        });
      setQuestions(questions);
    }
  }, [editorContent]);

  useEffect(() => {
    if (post !== null) {
      setAllowSubmission(post?.allow_submission ?? false);
    }
  }, [post]);

  const extraFields = useMemo(() => {
    const questionData =
      questions.length > 0 ? { field_question: questions } : undefined;
    return {
      allow_submission: allowSubmission,
      ...questionData,
    };
  }, [questions, allowSubmission]);

  return (
    <PostEdit
      entityType={"quiz"}
      apiEndpoint={apiEndpoints.quiz}
      screenClassName={"quizzes"}
      categoryTitle={"Quiz category"}
      categoryName={"field_quiz_category"}
      targetVid={"quiz_categories"}
      returnRoute={"/quizzes-creator"}
      backBtnText={"Quiz Library"}
      previewRoute={"/quizzes/preview"}
      logCustomEventType={"Quiz"}
      extraFields={extraFields}
      featuredImageEnabled={true}
      editorProps={{
        title: true,
        subtitle: true,
        body: true,
        list: true,
        table: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        buttonGroup: true,
        chart: true,
        map: true,
        question: true,
      }}
      disablereactions={true}
      disableComments={true}
      setEntityEditorContent={(body) => {
        setEditorContent(body);
      }}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      imageBlockEnabled={true}
    >
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={allowSubmission}
            onChange={(event) => {
              setAllowSubmission(event.target.checked);
            }}
          />
        }
        label={
          <Typography owner="admin" variant="body2">
            Require submission
          </Typography>
        }
      />
    </PostEdit>
  );
}
